/**
 * Action types for device Alarm Configation functionality.
 *
 * These constants are typically used in Redux action creators and reducers to handle user authentication.
 */

export const GET_DEVICE_CONFIG = 'GET_DEVICE_CONFIG';
export const GET_DEVICE_CONFIG_SUCCESS = 'GET_DEVICE_CONFIG_SUCCESS';
export const GET_DEVICE_CONFIG_FAIL = 'GET_DEVICE_CONFIG_FAIL';
export const EDIT_DEVICE_CONFIG = 'EDIT_DEVICE_CONFIG'
export const EDIT_DEVICE_CONFIG_COMPLETE =  'EDIT_DEVICE_CONFIG_COMPLETE';